<template v-if="dbName && colName" class="text-center">
    <div class="row gx-1 align-items-center">
        <div class="col-auto">
            {{ {
                'elements': '属性',
                'switches': '开关',
                'variables': '变量',
                'commonEvents': '公共事件',
                'troops': '敌群',
                'maps': '地图',
            }[colName] }}
        </div>
        <div class="col-4 col-sm-3 col-lg-2">
            <d-editable-select @click="queryList()" v-model="value" :options="options" max-height="300" allow-clear="true"></d-editable-select>
        </div>
        <div class="col-auto">
            <button type="submit" @click="querySource()" class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible = !visible" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible">
        <json-viewer
            :value="json"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
    <!-- <div class="row g-3 align-items-center">
        <div class="col-auto">
        </div>
    </div> -->
</template>
  
<script>
import axios from "@/utils/http"
import { CCollapse } from '@coreui/vue'
// import { CCard } from '@coreui/vue'
// import { CCardBody } from '@coreui/vue'
import { CButton } from '@coreui/vue'
import JsonViewer from 'vue-json-viewer'

export default {
    name: 'CommonQuery',
    components: {
        CCollapse, CButton,
        JsonViewer
    },
    data() {
        return {
            docList: null,
            visible: false,
            value:"",
            options:[],
            json:null,
        }
    },
    props: ['dbName', 'colName'],
    methods: {
        queryList(){
            if(this.docList == null){
                axios.post('/' + this.dbName + '/' + this.colName, { all: 1 })
                    // .then(response => { this.docList = [].concat(response.data) })
                    .then(response => {
                        this.docList = [].concat(response.data)
                        this.docList.forEach(doc => {
                            let id = doc['id'], name = doc['name'];
                            let label = String(id) + ': ' + name;
                            const maxLen = 10
                            if (label.length >= maxLen){
                                label = label.substring(0, maxLen) + "..."
                            }
                            let option = {'label': label, 'value': id,}
                            this.options.push(option)
                        });
                    })
            }
        },
        querySource(){
            // console.log(this.value)
            this.visible = true
            axios.post('/' + this.dbName + '/' + this.colName, { id: this.value, source:1 })
                .then(response => { this.json = response.data })
        },
    },
    created() {

    }
}
</script>
